import React, { useState, useEffect } from 'react';
import styles from './ConstituencyWise.module.css';

const ConstituencyWise = () => {
  const [constituencies, setConstituencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${hours}${minutes}`;

        const response = await fetch(`/result/ACF2021/json/element355.json?ver=${timestamp}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch results');
        }

        const data = await response.json();
        setConstituencies(data.items);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load constituency data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredConstituencies = constituencies.filter(constituency =>
    constituency.Const_Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className={styles.loading}>Loading constituency data...</div>;
  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Bihar Constituency Wise Results</h2>
        <div className={styles.searchBox}>
          <input
            type="text"
            placeholder="Search constituency..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
        </div>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.resultsTable}>
          <thead>
          <tr>
            <th>Constituency</th>
            <th>2025</th>
            <th>2020</th>
            <th>2015</th>
          </tr>
          </thead>
          <tbody>
          {filteredConstituencies.map((item, index) => (
            <tr key={index}>
              <td>{item.Const_Name}</td>
              <td>
                  <span
                    className={styles.partyBadge}
                    style={{ backgroundColor: `var(--${item.Party_2025.trim().toLowerCase()}-color)` }}
                  >
                    {item.Party_2025.trim().toUpperCase() || ''}
                  </span>
              </td>
              <td>
                  <span
                    className={styles.partyBadge}
                    style={{ backgroundColor: `var(--${item.Party_2020.trim().toLowerCase()}-color)` }}
                  >
                    {item.Party_2020.trim().toUpperCase() || ''}
                  </span>
              </td>
              <td>
                  <span
                    className={styles.partyBadge}
                    style={{ backgroundColor: `var(--${item.Party_2015.trim().toLowerCase()}-color)` }}
                  >
                    {item.Party_2015.trim().toUpperCase() || ''}
                  </span>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConstituencyWise;
